export const setActiveRadio = (currentOption, option) => {
    if (currentOption === option) {
        return true;
    }
    return false;
};
